<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t('schemaComptableComponent.popUpSchemaComptable.title')}}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content mgt-20px">
        <error-msg-component :messages="messages"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :error="error"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"/>
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field :label="$t('schemaComptableComponent.popUpSchemaComptable.libelle')"
                     class="obligatoire">
              <b-input v-model="schemaComptable.libelle" expanded></b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('schemaComptableComponent.popUpSchemaComptable.type')"
                     class="obligatoire">
              <b-select v-model="schemaComptable.type" expanded>
                <option v-for="value in listeTypeSchemaComptable"
                        :value="value.code" :key="value.code">
                  {{ $t(value.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-4">
            <b-tooltip class="width-100percent"
                  :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip'
                  )">
              <b-field :label="$t('schemaComptableComponent.popUpSchemaComptable.compteNormal')">
                <b-input expanded v-model="schemaComptable.compteNormal"></b-input>
              </b-field>
            </b-tooltip>
          </div>
          <div class="column is-4">
            <b-tooltip class="width-100percent"
                  :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip'
                  )">
              <b-field :label="$t('schemaComptableComponent.popUpSchemaComptable.compteExport')">
                <b-input expanded v-model="schemaComptable.compteExport"></b-input>
              </b-field>
            </b-tooltip>
          </div>
          <div class="column is-4">
            <b-field :label="$t('schemaComptableComponent.popUpSchemaComptable.produitConstate')">
              <b-input expanded v-model="schemaComptable.compteConstateDavance"></b-input>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field
              :label="$t('addSchemaComptable.informationCompteComptable.tvaSurEncaissement')">
              <qd-switch class="mgt-8px" v-model="schemaComptable.tvaSurEncaissement"></qd-switch>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field
              :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaEncaissement')">
              <b-input expanded v-model="schemaComptable.compteTvaEncaissement"></b-input>
            </b-field>
          </div>
          <div class="column is-4">
            <b-field
              :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebit')">
              <b-tooltip class="width-100percent"
                  :label="$t('schemaComptableComponent.popUpSchemaComptable.compteTvaDebitToolTip'
                  )">
                <b-input expanded v-model="schemaComptable.compteTva"></b-input>
              </b-tooltip>
            </b-field>
          </div>
          <div class="column is-4"/>
          <div class="column is-4" v-if="priseEnCompteRemiseCompta">
            <b-field
              :label="$t('schemaComptableComponent.popUpSchemaComptable.compteRemiseHorsRegie')">
              <b-input expanded v-model="schemaComptable.compteRemiseGeneral"></b-input>
            </b-field>
          </div>
          <div class="column is-4" v-if="priseEnCompteRemiseCompta">
            <b-field
              :label="$t('schemaComptableComponent.popUpSchemaComptable.compteRemiseRegie')">
              <b-input expanded v-model="schemaComptable.compteRemiseRegie"></b-input>
            </b-field>
          </div>
        </div>
        <b-field class="mgt-20px">
          <div class="is-pulled-left boutonAction">
            <a class="button is-annuler btn-modal-annuler" @click="$parent.close()">
              {{ $t('schemaComptableComponent.popUpSchemaComptable.actions.annuler') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-primary" @click="addSchemaComptable()">
              {{ $t('schemaComptableComponent.popUpSchemaComptable.actions.ajouter') }}
            </a>
          </div>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { LISTE_TYPE_SCHEMA_COMPTABLE } from '@/configuration/parametrage/schemaComptableConf';
import genererSchemaComptable from '@/services/parametrage/generation/genererSchemaComptable';
import { create } from '@/api/schemaComptable';
import messageSucces from '@/services/general/messageSucces';
import validation from '@/services/validation/validation';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'p_addNewSchemaComptable',
  data() {
    return {
      listeTypeSchemaComptable: LISTE_TYPE_SCHEMA_COMPTABLE,
      schemaComptable: genererSchemaComptable(),
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
    };
  },
  components: {
    errorMsgComponent,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    priseEnCompteRemiseCompta() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.remiseComptabilisee.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async addSchemaComptable() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        const schemaComptable = (await create(this.schemaComptable)).data.result;
        this.$parent.close();
        this.$emit('newSchemaComptable', schemaComptable);
        messageSucces(this.$t('schemaComptableComponent.popUpSchemaComptable.success.add'));
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validation(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, null);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.remiseComptabilisee.key]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
